import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import {connect} from 'react-redux';
import { fetchSessions } from '../../../store/actions/session.actions'
import { addMessage } from '../../../store/actions/message.actions';
import BounceJoinFileButton from "./bounceJoinFileButton.component";
import { bounceJoinFile } from "../../../api";

const BounceButtonContainer = ({
  sessionId,
  fileId,
  history,
  fetchSessions,
  disabled
}) => {
  const [ filename, setFilename ] = useState();

  const editFilename = (event) => setFilename(event.target.value);

  const onExport = async () => {
    try {
      await bounceJoinFile(sessionId, fileId, filename);
    } catch(err) {
      addMessage('error', err);
    }
    addMessage('success', 'New file created.');
    fetchSessions();
  }

  return (<BounceJoinFileButton editFilename={editFilename} disabled={disabled} onExport={onExport}/>)
}

BounceButtonContainer.propTypes = {
  sessionId: PropTypes.string.isRequired,
  fileId: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

export default withRouter(
  connect(null, { fetchSessions, addMessage }, )(BounceButtonContainer)
);
